import { cepMaskView } from 'utils/masks';

export const formatterEnderecoBackToFrontRequerimento = endereco => {
  return {
    id: endereco?.id || null,
    bairro: endereco?.bairro || null,
    cep: endereco?.cep ? cepMaskView(endereco?.cep) : null,
    cidade: endereco?.cidade || null,
    estado: endereco?.estado || null,
    logradouro: endereco?.logradouro || null,
    numero: endereco?.numero || null,
    pais: endereco?.pais || null,
    complemento: endereco?.complemento || null,
  };
};
